import React from "react";
import PropTypes from "prop-types";
import createReactClass from "create-react-class";

import CapacityBar from "./capacity_bar";

export default createReactClass({
  displayName: "Root",
  propTypes: {
    isOpen: PropTypes.bool.isRequired,
    closeModal: PropTypes.func.isRequired,
    fadeClassName: PropTypes.string.isRequired,
    publicTypeData: PropTypes.object.isRequired,
    initialTitle: PropTypes.string.isRequired,
    initialPublicType: PropTypes.number.isRequired,
    circleId: PropTypes.number.isRequired,
    photoStrageLimit: PropTypes.number.isRequired,
    chargePlanType: PropTypes.number.isRequired,
    isCirclePrivate: PropTypes.bool.isRequired,
    showAlbumCreateError: PropTypes.func.isRequired,
    showNetworkError: PropTypes.func.isRequired,
    showPublicSettingError: PropTypes.func.isRequired,
    showStrageError: PropTypes.func.isRequired,
    initialDesctription: PropTypes.string,
    userId: PropTypes.number,
    albumId: PropTypes.number,
    isEditMode: PropTypes.bool,
  },
  getInitialState() {
    return {
      title: this.props.initialTitle,
      publicType: this.props.initialPublicType,
      description: this.props.initialDesctription,
      isUploading: false,
      tempAlbumFileCapacity: 0,
      tempAllFileCapacity: 0,
    };
  },
  componentDidMount() {
    if (this.props.isEditMode) {
      this.loadTempFileCapacity(this.state.publicType);
    }
  },
  createAlbumToServer() {
    $.ajax({
      url: "/api/album/create_album",
      type: "POST",
      headers: {
        "X-CSRF-Token": document.getElementsByName("csrf-token")[0].content,
      },
      data: {
        circle_id: this.props.circleId,
        user_id: this.props.userId,
        title: this.state.title,
        public_type: this.state.publicType,
        description: this.state.description,
      },
      cache: false,
      success: function(data) {
        if (data) {
          window.location.href =
            "/circle/" + this.props.circleId + "/album/" + data;
        } else {
          this.setState({
            isUploading: false,
          });
          this.props.showAlbumCreateError();
        }
      }.bind(this),
      error: function() {
        this.setState({
          isUploading: false,
        });
        this.props.showNetworkError();
      }.bind(this),
    });
  },
  updateAlbumToServer() {
    $.ajax({
      url: "/api/album/update_album",
      type: "POST",
      dataType: "json",
      headers: {
        "X-CSRF-Token": document.getElementsByName("csrf-token")[0].content,
      },
      data: {
        album_id: this.props.albumId,
        title: this.state.title,
        public_type: this.state.publicType,
        description: this.state.description,
      },
      cache: false,
      success: function(data) {
        if (data != false) {
          window.location.href =
            "/circle/" + this.props.circleId + "/album/" + this.props.albumId;
        } else {
          this.setState({
            isUploading: false,
          });
          this.props.showAlbumCreateError();
        }
      }.bind(this),
      error: function() {
        this.setState({
          isUploading: false,
        });
        this.props.showNetworkError();
      }.bind(this),
    });
  },
  loadTempFileCapacity(publicType) {
    if (this.props.chargePlanType != 0) {
      return;
    }
    $.ajax({
      url: "/api/album/get_temp_file_capacity",
      type: "POST",
      headers: {
        "X-CSRF-Token": document.getElementsByName("csrf-token")[0].content,
      },
      data: {
        public_type: publicType,
        initial_public_type: this.props.initialPublicType,
        circle_id: this.props.circleId,
        album_id: this.props.albumId,
      },
      cache: false,
      success: function(data) {
        this.setState({
          tempAlbumFileCapacity: data.tempAlbumFileCapacity,
          tempAllFileCapacity: data.tempAllFileCapacity,
        });
      }.bind(this),
      error: function() {}.bind(this),
    });
  },
  onChangeTitleText(e) {
    this.setState({
      title: e.target.value,
    });
  },
  onChanePublicType(e) {
    this.setState({
      publicType: e.target.value,
    });
    if (this.props.isEditMode) {
      this.loadTempFileCapacity(e.target.value);
    }
  },
  onChangeDescriptionText(e) {
    this.setState({
      description: e.target.value,
    });
  },
  handleClose() {
    this.props.closeModal();
    this.loadTempFileCapacity(this.props.initialPublicType);
    setTimeout(
      function() {
        this.setState({
          title: this.props.initialTitle,
          publicType: this.props.initialPublicType,
          description: this.props.initialDesctription,
          isUploading: false,
        });
      }.bind(this),
      300
    );
  },
  handleCreateButton() {
    if (this.props.isCirclePrivate) {
      if (this.state.publicType == 4) {
        this.props.showPublicSettingError();
        return;
      }
    }
    if (this.props.isEditMode) {
      if (
        this.state.publicType == 2 &&
        this.props.initialPublicType == 4 &&
        this.state.tempAllFileCapacity >= this.props.photoStrageLimit
      ) {
        this.props.showStrageError();
      } else {
        this.setState({
          isUploading: true,
        });
        this.updateAlbumToServer();
      }
    } else {
      if (
        this.state.publicType == 2 &&
        this.props.allFileCapacity >= this.props.photoStrageLimit
      ) {
        this.props.showStrageError();
      } else {
        this.setState({
          isUploading: true,
        });
        this.createAlbumToServer();
      }
    }
  },
  render() {
    if (!this.props.isOpen) {
      return null;
    }
    var optionsForSelectInput = [];
    for (var i in this.props.publicTypeData) {
      optionsForSelectInput.unshift(
        <option value={i} key={i}>
          {this.props.publicTypeData[i].name}
        </option>
      );
    }
    var buttonName = this.props.isEditMode ? "保存" : "作成";
    var modalLoading = "";
    if (this.state.isUploading) {
      modalLoading = (
        <div id="modal-loading">
          <div id="loader">
            <i className="fas fa-spinner fa-pulse fa-2x fa-fw" />
          </div>
        </div>
      );
    }
    var capacityBar = "";
    if (this.props.chargePlanType == 0) {
      if (this.props.isEditMode) {
        capacityBar = (
          <CapacityBar
            allFileCapacity={this.state.tempAllFileCapacity}
            albumFileCapacity={this.state.tempAlbumFileCapacity}
            photoStrageLimit={this.props.photoStrageLimit}
          />
        );
      } else {
        capacityBar = (
          <CapacityBar
            allFileCapacity={this.props.allFileCapacity}
            photoStrageLimit={this.props.photoStrageLimit}
          />
        );
      }
    }

    return (
      <div className="album-create-modal">
        <div id={this.props.fadeClassName}>
          <div id="overAll">
            <div onClick={this.handleClose} id="overlay" />
            <div id="dialog">
              <div id="content">
                {modalLoading}
                <div id="body">
                  {capacityBar}
                  <div className="row mb-3">
                    <div className="col-md-12 col-sm-12">
                      <p>
                        <strong>アルバム名</strong>
                      </p>
                    </div>
                    <div className="col-md-12 col-sm-12">
                      <input
                        type="text"
                        className="form-control"
                        value={this.state.title}
                        placeholder="無題のアルバム"
                        onChange={this.onChangeTitleText}
                      />
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col-md-12 col-sm-12">
                      <p>
                        <strong>公開範囲</strong>
                      </p>
                    </div>
                    <div className="col-md-12 col-sm-12">
                      <select
                        className="form-control"
                        value={this.state.publicType}
                        onChange={this.onChanePublicType}
                      >
                        {optionsForSelectInput}
                      </select>
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col-md-12 col-sm-12">
                      <p>
                        <strong>説明</strong>
                      </p>
                    </div>
                    <div className="col-md-12 col-sm-12">
                      <textarea
                        className="form-control"
                        value={this.state.description}
                        placeholder=""
                        rows="2"
                        onChange={this.onChangeDescriptionText}
                      />
                    </div>
                  </div>
                </div>
                <div id="footer" style={{ displat: "flex" }}>
                  <button
                    className="btn btn-outline-secondary submit_button"
                    id="album_cancel_button"
                    style={{ width: "48.3%", textAlign: "center", margin: "0" }}
                    onClick={this.handleClose}
                  >
                    <a>キャンセル</a>
                  </button>
                  <button
                    type="button"
                    className="btn btn-info submit_button"
                    id="album_submit_button"
                    style={{
                      marginLeft: "8px",
                      width: "48.3%",
                      textAlign: "center",
                    }}
                    onClick={this.handleCreateButton}
                  >
                    {buttonName}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  },
});
